import { Fragment, useState } from "react";
import { MenuItem, Typography, Tooltip, Chip, Collapse, Checkbox } from "@mui/material";
import { tss } from "tss-react";
import { icons } from "constants/viewer";
import { getFileIcon } from "actions/GlobalActions";
import { FoldersActions } from "actions";
import { ArrowDropDown, ArrowRight } from "@mui/icons-material";
import commonStyles, { folderColor } from "styles/common";
import { useVersioning } from "constants/common";

const MENU_LIST_WIDTH = 600;
const useStyles = tss.create({
    rowContent: {
        width: "100%",
        height: 40,
        marginBottom: 5,
        display: "inline-flex",
        alignItems: "center",
    },
    labelAndIcon: {
        display: "inline-flex",
        width: "100%",
    },
    chipContainer: {
        position: "relative",
        display: "inline-flex",
    },
    arrow: {
        width: 16,
        height: 16,
        position: "relative",
    },
    icon: {
        width: 24,
        height: 24,
        minWidth: 24,
        minHeight: 24,
    },
    layerIcon: {
        display: "inline-flex",
        alignItems: "center",
        minWidth: 24,
        maxHeight: 24,
        marginRight: 5,
        marginLeft: 10,
        color: "rgb(0,0,0,0.53)",
    },
});

function getIcon(classes: any, file: any) {
    const fileName = getFileIcon(file);
    //console.log("fileName:", fileName);
    const Icon = icons[fileName];
    if (Icon) {
        return (
            <div className={classes.layerIcon}>
                <Icon className={classes.icon} />
            </div>
        );
    }
}

export default function ObjectInfo(props: {
    index: number;
    object: any;
    setEntity: any;
    updateSelection?: any;
    hasCheckbox?: boolean;
    hasChildren?: boolean;
    hideProducts?: boolean;
    children?: any;
    maxWidth?: number;
}) {
    const { classes } = useStyles();
    const { classes: common } = commonStyles();
    const { index, object, setEntity, updateSelection, hasCheckbox, hasChildren, hideProducts, children, maxWidth } =
        props;
    const [open, setOpen] = useState(false);

    const toggleCollapse = () => {
        setOpen(!open);
    };

    let strPath = FoldersActions.getPathFromEntity(object);
    let strPathShort = strPath;
    if (strPath && strPath.length > 35) {
        strPath = strPath.substring(0, 30) + "...";
    }
    const workflow = FoldersActions.getWorkflowFromEntity(object) || [];
    let products = workflow && workflow["products"] && workflow["products"].join(" - ");
    let productsShort = products;
    if (products && products.length > 35) {
        products = products.substring(0, 30) + "...";
    }

    return (
        <Fragment>
            <MenuItem
                className={classes.rowContent}
                value={object["name"]}
                style={{ maxWidth: maxWidth ? maxWidth : "" }}
            >
                {hasChildren && products ? (
                    <div className={common.middleCenter} onClick={toggleCollapse} style={{ width: 30 }}>
                        {open ? <ArrowDropDown className={classes.arrow} /> : <ArrowRight className={classes.arrow} />}
                    </div>
                ) : (
                    ""
                )}
                <div
                    style={{ display: "flex", width: "100%", maxWidth: 700, marginLeft: -4 }}
                    onClick={() => setEntity(index, object)}
                >
                    <div className={classes.labelAndIcon} style={{ width: "100%" }}>
                        {getIcon(classes, object)}
                        <Tooltip title={object["name"]} style={{ width: "100%" }}>
                            <Typography
                                noWrap
                                style={{
                                    maxWidth: MENU_LIST_WIDTH - 20,
                                }}
                            >
                                {object["name"]}
                            </Typography>
                        </Tooltip>
                    </div>
                    {useVersioning && (
                        <div
                            className={classes.chipContainer}
                            style={{
                                width: hideProducts ? "auto" : 440,
                                justifyContent: hideProducts ? "flex-end" : "",
                                overflow: "initial",
                            }}
                        >
                            {workflow === null || !workflow || !workflow["version"] ? (
                                <Fragment>
                                    <Chip label="Not Versioned" size="small" style={{ marginLeft: 7 }} />
                                    <Tooltip title={strPath}>
                                        <Chip
                                            label={strPathShort}
                                            size="small"
                                            style={{
                                                marginLeft: 7,
                                                width: 70,
                                                whiteSpace: "no-wrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                        />
                                    </Tooltip>
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <Tooltip title={workflow["comment"] ? workflow["comment"] : workflow["version"]}>
                                        <Chip
                                            label={workflow["version"]}
                                            size="small"
                                            style={{ marginLeft: 7, backgroundColor: folderColor }}
                                        />
                                    </Tooltip>
                                    {products && !hideProducts ? (
                                        <Tooltip title={productsShort}>
                                            <Chip label={products} size="small" style={{ marginLeft: 7 }} />
                                        </Tooltip>
                                    ) : (
                                        ""
                                    )}
                                </Fragment>
                            )}
                        </div>
                    )}
                </div>
                {hasCheckbox ? (
                    <Checkbox
                        id={"chk-" + object.ID}
                        itemID={object.ID}
                        onClick={(e: any) => updateSelection(e)}
                        tabIndex={index}
                        style={{ position: "absolute", right: 2 }}
                    />
                ) : (
                    ""
                )}
            </MenuItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                {children}
            </Collapse>
        </Fragment>
    );
}
